import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const FarmerVehicleInvoiceReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);
  const [seasonId, setSeasonId] = useState([]);
  const [seasondata, setSeasondata] = useState([]);
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);

  const [yieldExpanded, setYieldExpanded] = useState(false);
  const [revenueExpanded, setRevenueExpanded] = useState(false);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const { sendRequest: getfarmerdeal } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, seasonId, regionId) => {
    var newList = [];

    var urlfilter = "";

    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }
    if (seasonId != 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }
    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/farmerVehicleInvoiceReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        // console.log("reportdata1", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillprocurementData(employeeId, seasonId, regionId);
  }, [
    seasonId,
    employeeId,
    ranchId,
    fieldName,
    selectedFromDate,
    selectedToDate,
    showDateFilter,
    stateName,
  ]);

  useEffect(() => {
    if (!ranchId) {
      setFieldOptions([]);
      return;
    }

    var urlfilter = `&ranchId=${ranchId}`;

    getprocurementData(
      {
        url: `/api/farmerVehicleInvoiceReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}${urlfilter}`,
      },
      (res) => {
        const reportData = res || [];

        const uniqueFields = [
          ...new Set(
            reportData
              .map((item) => item.fieldCode)
              .filter(Boolean)
          ),
        ];

        const fieldList = uniqueFields.map((f) => ({
          fieldCode: f,
        }));

        setFieldOptions(fieldList);
      }
    );
  }, [ranchId]);

  const fieldsToExport = [
    "farmerNo",
    "farmerName",
    "ranchName",
    "fieldCode",
    "plotName",
    "seasonName",
    "plotArea",
    "yieldGood",
    "yieldBad",
    "yieldTotal",
    "revenueGood",
    "revenueBad",
    "totalRevenue",
    "yieldPerHectare",
    "yieldPerHaMT",
  ];

  const customHeaders = [
    "Farmer No",
    "Farmer Name",
    "Ranch Name",
    "Field Name",
    "Plot No",
    "Season Name",
    "Plot Size (ha)",
    "Yield - Good",
    "Yield - Bad",
    "Yield - Total",
    "Revenue - Good",
    "Revenue - Bad",
    "Total Revenue",
    "Yield per hectare",
    "Yield/Ha (MT)",
  ];

  const convertToExcel = (fields, filename, headers, data) => {
    if (
      !Array.isArray(fields) ||
      !Array.isArray(headers) ||
      !Array.isArray(data)
    ) {
      console.error("Fields, headers, and data must be arrays.");
      return;
    }
    if (fields.length !== headers.length) {
      console.warn(
        "Warning: fields and headers arrays have different lengths."
      );
    }

    // Prepare rows with headers as first row
    const worksheetData = [headers];

    // Map data objects to array of values based on fields order
    data.forEach((row) => {
      const rowData = fields.map((field) => {
        let value = row[field];
        if (value === null || value === undefined) value = "";
        return value;
      });
      worksheetData.push(rowData);
    });

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Write workbook to file and trigger download
    XLSX.writeFile(workbook, filename);
  };

  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const exportData = data.map((itm) => {
      // const yieldGood = itm.procurementDetails
      //   ? itm.procurementDetails
      //       .filter(
      //         (pd) =>
      //           pd.fruitQuality && pd.fruitQuality.toLowerCase() === "good"
      //       )
      //       .reduce((sum, pd) => sum + (pd.totalAmount || 0), 0)
      //   : 0;

      // const yieldBad = itm.procurementDetails
      //   ? itm.procurementDetails
      //       .filter(
      //         (pd) => pd.fruitQuality && pd.fruitQuality.toLowerCase() === "bad"
      //       )
      //       .reduce((sum, pd) => sum + (pd.totalAmount || 0), 0)
      //   : 0;

      // const yieldTotal = yieldGood + yieldBad;

      // const revenueGood = yieldGood * 135;
      // const revenueBad = yieldBad * 10;
      // const totalRevenue = revenueGood + revenueBad;
      var prddetai = itm.procurementDetails;
      let yieldBad = 0;
      let yieldGood = 0;
      let yieldTotal = 0;

      let revenueBad = 0;
      let revenueGood = 0;
      let totalRevenue = 0;



      prddetai.forEach((item) => {
        const amount =
          typeof item.totalAmount === "object"
            ? item.totalAmount.parsedValue
            : item.totalAmount;

        const quantity =
          typeof item.finalQuantity === "object"
            ? item.finalQuantity.parsedValue
            : item.finalQuantity;

        const amt = parseFloat(amount);
        const qty = parseFloat(quantity);


        if (item.fruitQuality === "Good") {
          revenueGood = revenueGood + amt;
          yieldGood = yieldGood + qty
        }

        if (item.fruitQuality === "Bad") {
          revenueBad = revenueBad + amt;
          yieldBad = yieldBad + qty
        }

        totalRevenue = totalRevenue + amt;
        yieldTotal = yieldTotal + qty;
      });

      const yieldPerHectare = itm.plotArea > 0 ? yieldTotal / itm.plotArea : 0;
      const yieldPerHaMT = yieldPerHectare / 1000;

      return {
        farmerNo: itm.farmerNo || "",
        farmerName: itm.farmerName || "",
        ranchName: itm.ranchName || "",
        fieldCode: itm.fieldCode || "",
        plotName: itm.plotName || "",
        seasonName: itm.seasonName || "",
        plotArea: itm.plotArea || 0,

        yieldGood,
        yieldBad,
        yieldTotal,
        revenueGood,
        revenueBad,
        totalRevenue,

        yieldPerHectare: yieldPerHectare.toFixed(2),
        yieldPerHaMT: yieldPerHaMT.toFixed(4),
      };


    });

    const filename = "Farmer Vehicle Invoice Report.xlsx";
    convertToExcel(fieldsToExport, filename, customHeaders, exportData);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);



  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  useEffect(() => {
    EmployeeDetail();
  }, [getEmp]);

  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Farmer Vehicle Invoice
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <br />
            </div>
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";
                      if (e.target.value != "--Select--") {
                        sId = e.target.value;
                      }
                      // setSeasonName(sName);
                      setSeasonId(sId);
                      EmployeeDetail(sId);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {seasondata &&
                      seasondata.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value || 0);
                      setFieldName("");
                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldCode}>
                        {x.fieldCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>
                    Field Officer
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"fromDate"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"toDate"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, seasonId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th
                            rowSpan={yieldExpanded || revenueExpanded ? 2 : 2}
                          >
                            Farmer No
                          </th>
                          <th rowSpan={2}>Farmer Name</th>
                          <th rowSpan={2}>Ranch Name</th>
                          <th rowSpan={2}>Field Name</th>
                          <th rowSpan={2}>Plot No</th>
                          <th rowSpan={2}>Season Name</th>

                          <th rowSpan={2}>Field Size (ha)</th>

                          {/* Yield main header */}
                          <th colSpan={yieldExpanded ? 3 : 1}>
                            Yield{" "}
                            <button
                              className="btn btn-link btn-sm p-0"
                              onClick={() => setYieldExpanded(!yieldExpanded)}
                            >
                              {yieldExpanded ? "+" : "-"}
                            </button>
                          </th>

                          {/* Revenue main header */}
                          <th colSpan={revenueExpanded ? 3 : 1}>
                            Revenue{" "}
                            <button
                              className="btn btn-link btn-sm p-0"
                              onClick={() =>
                                setRevenueExpanded(!revenueExpanded)
                              }
                            >
                              {revenueExpanded ? "+" : "-"}
                            </button>
                          </th>

                          <th rowSpan={2}>Yield per hectare</th>
                          <th rowSpan={2}>Yield/Ha (MT)</th>
                        </tr>

                        {/* Second row with sub-columns */}
                        <tr className="table-subheader">
                          {yieldExpanded ? (
                            <>
                              <th>Good</th>
                              <th>Bad</th>
                              <th>Total</th>
                            </>
                          ) : (
                            <th>Total</th>
                          )}

                          {revenueExpanded ? (
                            <>
                              <th>Good</th>
                              <th>Bad</th>
                              <th>Total</th>
                            </>
                          ) : (
                            <th>Total</th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            // const yieldGood = itm.procurementDetails
                            //   .filter(
                            //     (pd) =>
                            //       pd.fruitQuality?.toLowerCase() === "good"
                            //   )
                            //   .reduce(
                            //     (sum, pd) => sum + (pd.totalAmount || 0),
                            //     0
                            //   );

                            // const yieldBad = itm.procurementDetails
                            //   .filter(
                            //     (pd) => pd.fruitQuality?.toLowerCase() === "bad"
                            //   )
                            //   .reduce(
                            //     (sum, pd) => sum + (pd.totalAmount || 0),
                            //     0
                            //   );



                            // const yieldTotal = yieldGood + yieldBad;

                            // const revenueGood = yieldGood * 135;
                            // const revenueBad = yieldBad * 10;
                            // const totalRevenue = revenueGood + revenueBad; 
                            var prddetai = itm.procurementDetails;
                            let yieldBad = 0;
                            let yieldGood = 0;
                            let yieldTotal = 0;

                            let revenueBad = 0;
                            let revenueGood = 0;
                            let totalRevenue = 0;



                            prddetai.forEach((item) => {
                              const amount =
                                typeof item.totalAmount === "object"
                                  ? item.totalAmount.parsedValue
                                  : item.totalAmount;

                              const quantity =
                                typeof item.finalQuantity === "object"
                                  ? item.finalQuantity.parsedValue
                                  : item.finalQuantity;

                              const amt = parseFloat(amount);
                              const qty = parseFloat(quantity);


                              if (item.fruitQuality === "Good") {
                                revenueGood = revenueGood + amt;
                                yieldGood = yieldGood + qty
                              }

                              if (item.fruitQuality === "Bad") {
                                revenueBad = revenueBad + amt;
                                yieldBad = yieldBad + qty
                              }

                              totalRevenue = totalRevenue + amt;
                              yieldTotal = yieldTotal + qty;
                            });



                            const yieldPerHectare =
                              itm.plotArea > 0 ? yieldTotal / itm.plotArea : 0;
                            const yieldPerHaMT = yieldPerHectare / 1000;

                            return (
                              <tr key={i}>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.ranchName}</td>
                                <td>{itm.fieldCode}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.seasonName}</td>

                                <td>{formatNumber(itm.plotArea)}</td>
                                {/* Yield cells */}
                                {yieldExpanded ? (
                                  <>
                                    <td>{formatNumber(yieldGood)}</td>
                                    <td>{formatNumber(yieldBad)}</td>
                                    <td>{formatNumber(yieldTotal)}</td>
                                  </>
                                ) : (
                                  <td>{formatNumber(yieldTotal)}</td>
                                )}
                                {/* Revenue cells */}
                                {revenueExpanded ? (
                                  <>
                                    <td>{formatNumber(revenueGood)}</td>
                                    <td>{formatNumber(revenueBad)}</td>
                                    <td>{formatNumber(totalRevenue)}</td>
                                  </>
                                ) : (
                                  <td>{formatNumber(totalRevenue)}</td>
                                )}
                                <td>{formatNumber(yieldPerHectare)}</td>
                                <td>{formatNumber(yieldPerHaMT, 4)}</td>{" "}
                                {/* 4 decimals */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerVehicleInvoiceReport;
